<template>
    <main class="layout__main--narrow layout__main--no-top-padding">
        <BaseHeader
            v-if="page"
            :placeholder="pending"
        >
            <h1 v-if="page"> {{ page.title }} </h1>
            <h1 v-else><ContentPlaceholdersHeading /></h1>
        </BaseHeader>

        <template v-if="!pending && page">
            <BaseSection
                v-for="(category, index) in categories"
                :key="index"
                class="section--wide section--extra-spacing"
            >
                <template
                    v-if="guidelineCardsByType[category.id] && guidelineCardsByType[category.id].length"
                    #title
                >
                    <h2>{{ category.title }}</h2>
                </template>

                <BaseGuidelineCards
                    v-if="guidelineCardsByType[category.id] && guidelineCardsByType[category.id].length"
                    :cards="guidelineCardsByType[category.id]"
                />
            </BaseSection>

            <BaseSection
                v-if="guidelineCardsByType[0]"
                class="section--wide section--extra-spacing"
            >
                <template #title>
                    <h2>Other</h2>
                </template>

                <BaseGuidelineCards
                    v-if="guidelineCardsByType[0].length"
                    :cards="guidelineCardsByType[0]"
                />
            </BaseSection>

            <template v-if="quicklinksSections">
                <BaseQuicklinksSection
                    v-for="(quicklinksSection, index) in quicklinksSections"
                    :key="`quickLinks${index}`"
                    class="section--wide section--extra-spacing"
                    :lists="quicklinksSection.lists"
                >
                    <template #title>
                        <h2>{{ quicklinksSection.title }}</h2>
                    </template>
                </BaseQuicklinksSection>
            </template>
        </template>

        <!-- <template v-else>
            <BaseSection
                v-for="(category, index) in [1,2]"
                :key="index"
                class="section--wide section--extra-spacing"
            >
                <template #title>
                    <ContentPlaceholders>
                        <ContentPlaceholderTtext :lines="1" />
                    </ContentPlaceholders>
                </template>

                <BaseGuidelineCards :is-loading="true" />
            </BaseSection>
        </template> -->
    </main>
</template>

<script setup>
import {groupBy} from 'lodash-es';
import GuidelinesArchiveQuery from '~/graphql/queries/guidelines/archive.graphql';

const { activeSite } = useMultisite();
const { uriFromEntryFields } = useUri();
const { variables } = useCraftGraphql();

if (activeSite.value?.handle) {
    variables.site = activeSite.value?.handle;
}

const response = await useLazyAsyncQuery({
    query: GuidelinesArchiveQuery,
    variables
});

const { data: entry } = response;

const {
    craftEntry: page,
    pending,
} = usePageQuery(
    response,
    { entryKey: 'page', activeSite }
);

const guidelines = computed(() => {
    if (!entry.value?.guidelines) {
        return [];
    }

    return entry.value?.guidelines;
});

const categories = computed(() => {
    if (!entry.value?.categories) {
        return [];
    }

    return entry.value?.categories;
});

const quicklinksSections = computed(() => {
    return page.value?.quickLinks?.map((section) => {
        return {
            title: section.title,
            lists: section.children?.map((list) => {
                return {
                    links: list.links?.map((link) => {
                        return {
                            text: link.text,
                            uri: uriFromEntryFields(link)
                        };
                    })
                };
            })
        };
    });
});

const guidelineCardsByType = computed(() => {
    const cards = guidelines?.value?.map((guideline) => {
        return {
            title: guideline.title,
            url: `/guidelines/archive/${guideline.slug}`,
            category: guideline.guidelineCategory
        };
    });

    return groupBy(cards, (item) => {
        if (item.category?.[0]?.id) {
            return item.category[0].id;
        }
        return 0;
    });
});
</script>
